import type { SerializedConstructor } from '@langchain/core/load/serializable';

import { parseLangSmithParamsFromRun } from '@/utils/langsmith-params';

import type { ManifestPreviewProps } from '../../Manifest.utils';

export const MODELS = [
  'grok-2-1212',
  'grok-2-vision-1212',
  'grok-3-mini-fast',
  'grok-3-fast',
  'grok-3-mini',
  'grok-3',
  'grok-4',
].map((value) => ({
  label: value,
  value,
}));

export const DEFAULT_MODEL = 'grok-4';

export const getXAIModelCapabilities = (model: string) => {
  const isReasoning =
    model.startsWith('grok-4') || model.startsWith('grok-3-mini');
  return {
    isReasoning,
  };
};

export function useChatXAIModelAndProvider(
  props: ManifestPreviewProps<SerializedConstructor>
) {
  const id = props.value.id.at(-1) ?? '';
  const kwargs = props.value.kwargs;
  const model = kwargs.model ?? kwargs.model_name ?? DEFAULT_MODEL;

  return {
    model,
    provider: id,
  };
}

export function inferChatXAIManifestFromRun(
  params: ReturnType<typeof parseLangSmithParamsFromRun>,
  serializedModel: SerializedConstructor | null
): SerializedConstructor | null {
  if (
    params?.ls_provider !== 'xai' ||
    !(params?.ls_model_type == null || params.ls_model_type === 'chat')
  ) {
    return null;
  }

  const clientOptions = serializedModel?.kwargs.client_options;

  return {
    lc: 1,
    type: 'constructor',
    id: ['langchain_xai', 'chat_models', 'ChatXAI'],
    kwargs: {
      ...(params.ls_model_name !== undefined && {
        model: params.ls_model_name,
      }),
      ...(params.ls_temperature !== undefined && {
        temperature: params.ls_temperature,
      }),
      ...(params.ls_max_tokens !== undefined && {
        max_tokens: params.ls_max_tokens,
      }),
      ...(clientOptions !== undefined && {
        ...(clientOptions?.base_url && { base_url: clientOptions?.base_url }),
        ...(clientOptions?.timeout && { timeout: clientOptions?.timeout }),
        ...(clientOptions?.max_retries && {
          max_retries: clientOptions?.max_retries,
        }),
        ...(clientOptions?.default_headers && {
          default_headers: clientOptions?.default_headers,
        }),
      }),
      client_options: undefined,
    },
  };
}
